<script setup lang="ts">
definePageMeta({
  layout: "no-bread-crumbs",
});

useHead({
  title: "職人さん募集！応募フォーム",
  meta: [
    {
      name: "description",
      content:
        "職人さん募集！応募フォーム｜外溝(外構)工事 エクステリアのファミリー庭園。",
    },
  ],
});
const { isAgree, recruitData, resetData } = useRecruit();
const { isChange } = useLeaveForms();

if (recruitData.value.form_type != "contractor") {
  // formtypeが異なる場合リセットをかける
  resetData();
  // formtypeを現在のformtypeに設定
  recruitData.value.form_type = "contractor";
}

watchOnce(
  () => recruitData.value,
  () => {
    isChange.value = true;
    recruitData.value.recruit_cd = 3;
  },
  { deep: true },
);

function handleSubmit(e: Event) {
  isChange.value = false;
  useRouter().push("/recruit/confirm");
}
</script>

<template>
  <RecruitPage type="contractor">
    <template #content>
      <div>
        <ImageEl
          class="w-full max-w-[540px] mx-auto"
          src="/images/recruit/contractor_top.png"
          alt="職人さん募集"
          width="540"
          height="420"
          sizes="sm:100% md:540px"
          format="webp"
        />
        <div class="body">
          <p class="mb-4">
            当社で永いお付き合いをしている職方様は沢山いるのですが、今のメンバーだけでは、年間2500件の工事対応が限度です。
          </p>
          <div class="flex flex-col tablet:flex-row mb-8">
            <div class="tablet:w-2/3 my-auto">
              <p class="mb-4">
                有難い事なんですが、当社は年々お客様の支持を頂いておりまして、どの職方様もフル回転でして…。
              </p>

              <p class="mb-4">
                おこがましいのですが、ご縁を頂き、肌の合う職方様とは、切れ目なく仕事をお願いしているのが現状です。
              </p>

              <p class="mb-4">
                当社がヨチヨチの頃からお付き合いしている業者様も、当時は一人親方だった方々が、今では複数の職人を束ねる親方となり、共に成長してきた戦友として一緒に「お客様の利益」を生産して参りました。
              </p>

              <p>
                が、今ではその成長以上の速さで、事業規模が拡大し、新しい職方様が必要となり、継続的な募集をする運びとなりました。
              </p>
            </div>
            <div class="tablet:w-1/3">
              <ImageEl
                class="mx-auto w-full p-4"
                src="/images/recruit/contractor_1.png"
                width="616"
                height="540"
                alt="職人さん"
                sizes="sm:100% lg:500px"
                format="webp"
              />
            </div>
          </div>

          <p class="font-bold text-lg mb-8">
            当社は、今では関西No,1の外構業者となりました。財務体質においても、年々安定度は増しております。
          </p>

          <div class="flex flex-col tablet:flex-row mb-8">
            <div class="tablet:w-1/3 mb-4">
              <ImageEl
                class="mx-auto w-full p-4"
                src="/images/recruit/contractor_2.png"
                width="616"
                height="540"
                alt="お支払い"
                sizes="sm:100% lg:500px"
                format="webp"
              />
            </div>
            <div class="tablet:w-2/3 my-auto">
              <p class="mb-4">
                そして、当然ながら職方様が一番に心配されるのは、支払です。
              </p>
              <p class="mb-4">
                職人さんたちは、横の繋がりが強いので、もうご存知かもしれませんが、
              </p>
              <p class="font-bold mb-4">
                当社は支払いにおいての不備は皆無です。
              </p>
              <p>
                ・末締め/翌末　現金振込みが最長のスパンです。（有能な方などには、すぐ払いなどもしております）
              </p>
            </div>
          </div>
          <div class="mb-8">
            <h2 class="text-lg text-[#53772E] font-bold">
              ■当社が職方様に求めていること。
            </h2>
            <ul class="list-disc px-8">
              <li>ウソをつかれない方</li>
              <li>約束を守れる方</li>
              <li>真面目な方</li>
              <li>継続取引をして頂ける方</li>
              <li>できれば背負うものを持っている方</li>
              <li>最後に、「欲」のある方</li>
            </ul>
          </div>

          <div class="mb-8">
            <h2 class="text-lg text-[#53772E] font-bold">■募集エリア</h2>
            <ul class="px-4">
              <li>
                <p class="font-bold">外構職方・水まわり職方（個人・法人</p>
                <p>関西2府4県全域 (大阪・兵庫・京都・奈良・和歌山・滋賀)</p>
              </li>
              <li>
                <p class="font-bold">エクステリア職方</p>
                <p>関西全域・中京全域・関東（東京,千葉,埼玉,茨城）</p>
              </li>
            </ul>
          </div>

          <div class="mb-8">
            <h2 class="text-lg text-[#53772E] font-bold">
              ■面談、お取引につきまして
            </h2>
            <ul class="px-4">
              <li>随時、各店長が折り返しご連絡（TEL・メール）致します。</li>
            </ul>
          </div>

          <div class="mb-8">
            <h2 class="text-lg text-[#53772E] font-bold">■申し込み方法</h2>
            <div class="px-4">
              <p>
                お電話、もしくは以下の専用メールフォームよりご連絡ください。
                後日、店長より折り返しご連絡（TEL・メール）し、詳しくお話させて頂きます。
              </p>
              <NuxtLink
                class="font-bold underline"
                to="/contents.php/profile"
                target="_blank"
                >ファミリー庭園　会社概要</NuxtLink
              >
            </div>
          </div>
          <div class="mb-8">
            <p class="text-lg text-center mb-4">
              お電話の方は、<span class="font-bold text-xl">06-6777-9544</span>
            </p>
            <p class="text-lg text-center">
              メールの方は、下記フォームからお申し込みください。
            </p>
          </div>
        </div>
      </div>
    </template>
    <template #form>
      <FormParent :submit="handleSubmit">
        <RecruitForm type="contractor" />
      </FormParent>
    </template>
  </RecruitPage>
</template>
